import React, { useEffect, useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
const EditLeadPriority = () => {
    const token = localStorage.getItem("authToken");
    const [formData, setFormData] = useState({});
    const location = useLocation();
    const { data } = location.state || {};
    console.log(data, "leadpriorityData");
    const [loading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const [editLeadPriority, setEditLeadPriority] = useState([]);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const authToken = localStorage.getItem("authToken");

    const [ userTypedd, setUserTypedd ] = useState([])
    const userType = localStorage.getItem("UserType")
    const businessPartnerId = localStorage.getItem("business_partner_id")


    useEffect(() => {
        userTypedropdown()
      },[])
      
      const userTypedropdown = async () => {
        try{
          const response = await axiosInstance.get("/bp-onboard/bplist",{
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          })
      
          const data = response.data.data.data
          const userTypeOptions = data.map(user => ({
            value: user.onboard_id,
            label:user.bp_name,
          }))
          setUserTypedd(userTypeOptions)
        }catch(error) {
          console.log(error)
        }
      }

    useEffect(() => {
        fetchLeadPriorityEdit();
    }, []);

    const navigate = useNavigate();

    const fetchLeadPriorityEdit = async () => {

        try {
            const response = await axiosInstance.get(`/priority/edit/${data.priority_id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            const fetchedData = response.data.data
            const formatedData = {
              business_partner_id:fetchedData.business_partner_id,
                priority_name:fetchedData.priority_name,
                priority_desc:fetchedData.priority_desc,
                business_partner_id:fetchedData.business_partner_id,
                status: fetchedData.status === 1 ? "Active" : "Inactive",
            } 
            setFormData(formatedData)
            setEditLeadPriority(fetchedData);
            console.log("fetchedData", fetchedData);
        } catch (error) {
            console.log(error);
        }
    };

    const handleFormSubmit = async (formData) => {
      const errors = {};
      let isValid = true;
      CustomerInputs.forEach((field) => {
        if (field.validation && field.validation.required) {
          if (!formData[field.name]) {
            errors[field.name] = "This field is required";
            isValid = false;
          }
        }
      });
      if (!isValid) {
        setValidationErrors(errors);
        return;
      }
    
      console.log("formData", formData);
      const result = await Swal.fire({
        title: "Confirmation",
        text: "Are you sure you want to update this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });
      if (!result.isConfirmed) {
        Swal.fire({
          title: "Cancelled",
          text: "The action has been cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
        //setLoading(false); 
        return;
      }
      try {
        setLoading(true);
        const payload = {
          priority_name: formData.priority_name,
          priority_desc: formData.priority_desc,
          status: formData.status === "Active" ? 1 : 0,
        };
    
        if (userType === "superadmin") {
          payload.business_partner_id = formData.business_partner_id;
        } else {
          payload.business_partner_id = businessPartnerId;
        }
        setIsFormSubmitted(true);
        await axiosInstance.patch(`/priority/update/${data.priority_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        Swal.fire({
          title: "Success",
          text: "Lead Priority updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
          
        }).then(() => {
          navigate(ROUTES_NAVIGATION.LEADPRIORITYLIST);
        });;
      } catch (error) {
        console.error("Error updating lead priority:", error);
    
        const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
        Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    };
    

    const CustomerInputs = [
        ...(userType === "superadmin"
            ? [
                {
                  name: "business_partner_id",
                  label: "Business Partner",
                  type: "dropdown",
                  required: true,
                  options: userTypedd,
                  gridClass: "col-lg-4",
                  
                },
              ]
            : []),
        {
            name: "priority_name",
            label: "Lead Priority Name",
            type: "text",
            required: true,
            validation: {
            required: true,
            pattern: /^[A-Za-z0-9-\s]*$/,
            message: "Special symbols are not allowed",
          },
            gridClass: "col-lg-4",
        },
        {
            name: "priority_desc",
            label: "Description",
            type: "text",
            required: true,
            gridClass: "col-lg-4",
        },
        {
          name: "status",
          label: "Status",
          type: "dropdown",
          required: true,
          options: [
            { label: "Active", value: "Active" },
            { label: "Inactive", value: "Inactive" },
          ],
          validation: {
            required: true,
            message: "Status is required",
          },
          gridClass: "col-lg-4",
        },
    ];

    return (
        <>
         {loading ? (
        <Loader/>
      ) : (
        <>
            <div className="backbutton mt-2 mb-2">
                <img src={backicon} alt="back" onClick={() => navigate(ROUTES_NAVIGATION.LEADPRIORITYLIST)} />
                <span className="backbtntitle">Edit Lead Priority</span>
            </div>
            <div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                    Please Edit the Lead Priority Details
                </span>
                <DynamicForm
                    formConfig={CustomerInputs}
                    formData={formData}
                    setFormData={setFormData}
                    onSubmit={handleFormSubmit}
                    validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
                />
            </div>
            <div className="btncontainer mt-3">
                <button
                    onClick={() => handleFormSubmit(formData)}
                    className="submit-btn"
                >
                    Submit
                </button>
            </div></>
      )}
        </>
    );
};

export default EditLeadPriority;
